<template>
  <div class="diagram-container content-container">
    <section class="diagram_sidebar">
      <validation-observer ref="formValidator">
        <div class="das-form-container das-form-group">
          <div class="das-form-input">
            <div class="label">
              {{ 'Ngày' }}
            </div>
            <CalendarSelect
              :value="$moment().format('YYYY-MM-DD')"
              mode="date"
              disabled
            />
          </div>
          <div class="das-form-input">
            <div class="label">
              {{ 'Khách sạn' }}
            </div>
            <validation-provider rules="required" name="Khách sạn">
              <el-select v-model="queryParams.hotelId" filterable>
                <el-option
                  v-for="item in hotelOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </validation-provider>
          </div>
          <!-- <div class="das-form-input">
            <div class="label">
              {{ 'Tầng' }}
            </div>
            <validation-provider rules="required|integer" name="Tầng">
              <input v-model="queryParams.floor" v-numeric-only type="text" />
            </validation-provider>
          </div> -->
        </div>
      </validation-observer>
      <div class="diagram_sidebar_buttons">
        <button class="btn primary small" @click="onFilter">Tìm kiếm</button>
      </div>
      <div class="diagram_sidebar_statuses"></div>
      <div class="diagram_sidebar_tags"></div>
      <div class="diagram_sidebar_tag-status-list">
        <RoomStatusTagItem
          v-for="item in [...statuses, ...tags]"
          :key="item?.key"
          :label="item?.label"
          :icon="item?.icon"
          :html="item?.html"
          :quantity="item?.quantity"
        />
      </div>

      <!-- <svg-icon class-name="search-icon" icon-class="mci_info" /> -->
      <!-- <IconSvg icon="mci_clock" /> -->
    </section>
    <section v-loading="diagramLoading" class="diagram_data">
      <div class="diagram_data-container">
        <RoomStatusCard
          v-for="room in rooms"
          :key="room.room_id"
          :room-info="room"
          @click="fnOpenRoomDetailDialog(room)"
        >
        </RoomStatusCard>
      </div>
    </section>
    <RoomStatusDetailDialog
      v-if="isShowDetailDialog"
      :room-info="roomInfo"
      :hotel-name="currentHotelName"
      @close="fnCloseRoomDetailDialog"
      @resetData="attachData"
    ></RoomStatusDetailDialog>
  </div>
</template>
<script>
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import RoomStatusCard from './components/RoomStatusCard.vue'
import RoomStatusDetailDialog from './components/RoomStatusDetailDialog.vue'
import RoomStatusTagItem from './components/RoomStatusTagItem.vue'
import IconSvg from '@/components/IconSvg/index.vue'
import { ROOM_STATUS_COLORS, ROOM_TAG_ICONS } from './constants.js'

import { getAllHotel } from '@/api/hotel.js'
import { getRoomDiagramHouseKeepingApi } from '@/api/chamber_service/roomDiagram'
import { roomInfo } from './stores'

// const ROOM_STATUS_COLORS = {
//   DIRTY: 'red',
//   CLEAN: 'yellow',
//   READY: 'green',
//   OOO: 'black',
//   FOC: 'pink',
//   BOOKED: 'blue'
// }

// // eslint-disable-next-line no-unused-vars
// const ROOM_TAG_ICONS = {
//   GROUP: '',
//   OOO: '',
//   OOS: '',
//   DIFF: '',
//   EMPTY_ROOM: '',
//   ARRIVE: '',
//   DEPART: '',
//   IN_HOUSE: '',
//   LONG_STAY: '',
//   SHORT_STAY: '',
//   MISSION_WARN_COMMENT_MESS: '',
//   LOCK_TRANSFER: ''
// }

// eslint-disable-next-line no-unused-vars
const getDefaultRoomStatusList = () => [
  {
    key: 'dirty_room',
    label: 'Phòng bẩn',
    html: `<div style="width: 100%; height: 12px; background-color: ${ROOM_STATUS_COLORS.DIRTY}"></div>`,
    quantity: null
  },
  {
    key: 'clean_room',
    label: 'Phòng sạch',
    html: `<div style="width: 100%; height: 12px; background-color: ${ROOM_STATUS_COLORS.CLEAN}"></div>`,
    quantity: null
  },
  {
    key: 'ready_room',
    label: 'Phòng đã kiểm tra',
    html: `<div style="width: 100%; height: 12px; background-color: ${ROOM_STATUS_COLORS.READY}"></div>`,
    quantity: null
  }
]

const getDefaultRoomTagList = () => [
  {
    key: 'group',
    label: 'Đoàn',
    icon: null,
    quantity: null,
    html: `<div style="width: 100%; height: 30px; background-color: #2b8e59; position: relative; border-radius: 4px; overflow: hidden">
      <div style="position: absolute; right: 0; border-style: solid; border-color: transparent #ff9191 transparent transparent; border-width: 0 14px 14px 0"></div>
    </div>`
  },
  {
    key: 'ooo',
    label: 'OOO',
    icon: ROOM_TAG_ICONS.OOO,
    quantity: null
  },
  {
    key: 'oos',
    label: 'OOS',
    icon: ROOM_TAG_ICONS.OOS,
    quantity: null
  },
  {
    key: 'diff',
    label: 'Sai lệch',
    icon: ROOM_TAG_ICONS.DIFF,
    quantity: null
  },
  {
    key: 'empty_room',
    label: 'Phòng trống',
    icon: ROOM_TAG_ICONS.AVAILABLE_ROOM,
    quantity: null
  },
  {
    key: 'depart',
    label: 'Đến hạn đi',
    icon: ROOM_TAG_ICONS.DEPART,
    quantity: null
  },
  {
    key: 'arrive',
    label: 'Đến hôm nay',
    icon: ROOM_TAG_ICONS.ARRIVE,
    quantity: null
  },
  {
    key: 'in_house',
    label: 'Đang ở',
    icon: ROOM_TAG_ICONS.IN_HOUSE,
    quantity: null
  },
  // {
  //   key: 'long_stay',
  //   label: 'Ở dài hạn',
  //   icon: ROOM_TAG_ICONS.LONG_STAY,
  //   quantity: null
  // },
  // {
  //   key: 'short_stay',
  //   label: 'Ở ngắn hạn',
  //   icon: ROOM_TAG_ICONS.SHORT_STAY,
  //   quantity: null
  // },
  // {
  //   key: 'group',
  //   label: 'Sinh nhật',
  //   icon: '',
  //   quantity: null
  // },
  // {
  //   key: 'group',
  //   label: 'Phòng trăng mật',
  //   icon: '',
  //   quantity: null
  // },
  // {
  //   key: 'group',
  //   label: 'Hết hạn lưu trú',
  //   icon: '',
  //   quantity: null
  // },
  {
    key: 'mission_warn_comment_mes',
    label: 'Nhiệm vụ, Cảnh báo, Bình luận, Tin nhắn',
    icon: ROOM_TAG_ICONS.MISSION_WARN_COMMENT_MESS,
    quantity: null
  },
  {
    key: 'lock_transfer',
    label: 'Khóa chuyển phòng',
    icon: ROOM_TAG_ICONS.LOCK,
    quantity: null
  }
]

// eslint-disable-next-line no-unused-vars
const mockData = [
  {
    id: 78,
    sub_booking_group_id: 1,
    room_id: 110,
    room_num: '02',
    room_x: '120',
    room_y: '0',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 2,
    room_status: 1,
    group_color: '#2342df',
    foc: true,
    arrive: false,
    depart: false,
    in_house: false,
    diff: false,
    empty_room: false,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  },
  {
    id: 79,
    sub_booking_group_id: null,
    room_id: 111,
    room_num: '03',
    room_x: '120',
    room_y: '90',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: '2024-01-01',
    to_date: '2024-01-10',
    from_date_next: null,
    to_date_next: null,
    booking_room_status: null,
    room_status: 2,
    group_color: null,
    foc: false,
    arrive: false,
    depart: false,
    in_house: false,
    diff: false,
    oos: false,
    ooo: true,
    empty_room: true,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  },
  {
    id: 80,
    sub_booking_group_id: null,
    room_id: 112,
    room_num: '04',
    room_x: '240',
    room_y: '90',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 4,
    room_status: 1,
    group_color: null,
    foc: false,
    arrive: false,
    depart: false,
    in_house: false,
    diff: false,
    empty_room: true,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  },
  {
    id: 81,
    sub_booking_group_id: null,
    room_id: 113,
    room_num: '05',
    room_x: '0',
    room_y: '200',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 2,
    room_status: 4,
    group_color: null,
    foc: false,
    arrive: false,
    depart: true,
    in_house: false,
    diff: false,
    empty_room: false,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false,
    oos: true
  },
  {
    id: 77,
    sub_booking_group_id: null,
    room_id: 109,
    room_num: '01',
    room_x: '0',
    room_y: '0',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 1,
    room_status: 2,
    group_color: null,
    foc: false,
    arrive: false,
    depart: false,
    in_house: false,
    diff: false,
    empty_room: false,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  },
  {
    id: 77,
    sub_booking_group_id: 12,
    room_id: 109,
    room_num: '06',
    room_x: '240',
    room_y: '240',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 4,
    room_status: 2,
    group_color: 'wheat',
    foc: false,
    arrive: false,
    depart: false,
    in_house: true,
    diff: false,
    empty_room: false,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  },
  {
    id: 77,
    sub_booking_group_id: 12,
    room_id: 109,
    room_num: '07',
    room_x: '120',
    room_y: '240',
    width: 100,
    height: 80,
    room_level_name: 'Test01',
    from_date: null,
    to_date: null,
    from_date_next: null,
    to_date_next: null,
    booking_room_status: 4,
    room_status: 4,
    group_color: 'wheat',
    foc: false,
    arrive: true,
    depart: true,
    in_house: false,
    diff: false,
    empty_room: false,
    long_stay: false,
    short_stay: true,
    mission_warn_comment_mes: false,
    lock_transfer: false
  }
]

export default {
  components: {
    CalendarSelect,
    RoomStatusCard,
    RoomStatusDetailDialog,
    RoomStatusTagItem,
    // eslint-disable-next-line vue/no-unused-components
    IconSvg
  },
  data() {
    return {
      tags: getDefaultRoomTagList(),
      statuses: getDefaultRoomStatusList(),
      roomStatusOptions: [],
      roomTagOptions: [],
      queryParams: {
        roomLevelId: null,
        hotelId: null
        // floor: 1
      },
      rooms: [],
      // rooms: [],
      roomInfo: null,
      isShowDetailDialog: false,
      diagramLoading: false,
      hotelOptions: [],
      currentHotelName: null
    }
  },
  async mounted() {
    // await Promise.all([this.getRoomTagOptions(), this.getRoomStatusOptions()])
    await this.getHotelOptions()
    this.queryParams.hotelId = this.hotelOptions?.[0].id
    this.attachData()
  },
  methods: {
    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    async getRoomTagOptions() {
      this.tags.forEach((tag, index) => {
        this.roomTagOptions.push({
          id: index,
          name: tag
        })
      })
    },
    async getRoomStatusOptions() {
      this.statuses.forEach((status, index) => {
        this.roomStatusOptions.push({
          id: index,
          name: status
        })
      })
    },
    async getRoomStatusData() {},

    // ACTIONS
    async onFilter() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      this.attachData()
    },

    fnOpenRoomDetailDialog(roomClicked) {
      this.roomInfo = Object.assign(roomInfo, roomClicked)
      this.isShowDetailDialog = true
    },

    fnCloseRoomDetailDialog() {
      this.isShowDetailDialog = false
    },

    async attachData() {
      this.diagramLoading = true
      getRoomDiagramHouseKeepingApi(this.queryParams)
        .then(res => {
          this.rooms = res.data.room_diagram
          this.currentHotelName = res.data.hotel_name

          this.tags = this.tags.map((item, index) => ({
            ...item,
            quantity: res.data[item.key]
          }))
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.diagramLoading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
.das-form-input {
  position: relative;
}

.diagram-container {
  padding: 0;
  display: grid;
  grid-template-columns: auto 1fr;
}
.diagram_sidebar {
  padding: 16px;
  width: 320px;
  border-right: 1px solid var(--das-border-color);
  &_buttons {
    margin-top: 12px;
    text-align: right;
  }
  display: flex;
  max-height: 100%;
  flex-direction: column;
  overflow: hidden;
}

.diagram_data {
  // height: min-content;
  height: 100%;
  gap: 8px;
  padding: 16px;
  overflow: scroll;
  // display: grid;
  // grid-template-columns: repeat(auto-fit, 180px);
}

.diagram_data-container {
  min-width: 100%;
  min-height: 100%;
  position: relative;
}

.diagram_sidebar_tag-status-list {
  margin: 16px 0;
  flex-shrink: 1;
  overflow-y: scroll;
}
</style>
